export default __webpack_public_path__ + "images/79f96739d716af759c65423b6e0d2453.svg";